export default __webpack_public_path__ + "static/media/03_photo.ddb1c599.jpg";